import React from "react";
import { H3, LI, P, UL } from "../../AbstractElements";
import { CheckAll, Notifications } from "../../Constant";
import { Link } from "react-router-dom";
import { NOTIFICATION } from "../../Data/Header/Notification";

const NotificationDropBox = () => {
  return (
    <div className="onhover-show-div notification-dropdown">
      <H3 className="f-18 mb-0 dropdown-title">{Notifications}</H3>
      <UL>
        {NOTIFICATION.map((item,index) => (
          <LI className={`border-4 b-t-${item.boxColor ? item.boxColor  : item.fontColor} `} key={index}>
            <P>
              <Link to={item.url}>{item.title}</Link>
              <span className={`font-${item.fontColor}`}>{item.time}</span>
            </P>
          </LI>
        ))}
        <LI className="check-button">
          <Link className="f-w-500" to={`${process.env.PUBLIC_URL}/chat/chat`}>{CheckAll}</Link>
        </LI>
      </UL>
    </div>
  );
};

export default NotificationDropBox;
